<div [hidden]='!lineChart'>
  <canvas id="lineChartCanvas">{{ lineChart }}</canvas>
</div>
